import version from "../../resources/data/version";

class VersionUtil {
  static getCurrentVersion() {
    return version.version;
  }
}

export default VersionUtil;